import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './containers/App/App';
import { BrowserRouter } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';
import baseStyles from './styles';
import store from './store';
import { ErrorBoundry } from 'logger/bugsnag';

const { version } = require('../package.json');

window.appVersion = version;

const render = () => {
  baseStyles();

  ReactDOM.render(
    <ErrorBoundry>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </ErrorBoundry>,
    document.getElementById('root')
  );
  registerServiceWorker();
};

render();



// WEBPACK FOOTER //
// ./src/index.js